
import AdharPayMain from "../../components/aadhar-pay-report/AdharPayMain"

export const AdharPayReport = ({ title_1, title_2, title }) => {
   
    return <div>
        <AdharPayMain title_1={title_1} title_2={title_2} title={title} />
    </div>
}